export default "__VITE_ASSET__BxCt0TYS__"